import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Table from '../../../components/table/table.jsx';
import * as FileSaver from 'file-saver';
import { selectTanksStateOperations, selectTanksStateOperationsFilter } from '../../../state/selectors/tanks.js';
import tankService from '../../../services/tanksService.js';
import appService from '../../../services/appService.js';
import { useLocalization } from '../../../hooks/useLocalization.js';
import Loader from '../../../components/loader/loader.jsx';

const Columns = [
    {
        header: "TankStateOperation.tankName",
        name: "tankName"
    },
    {
        header: "TankStateOperation.watterLevelHeight",
        name: "watterLevelHeight",
        dataType: "int"
    },
    {
        header: "TankStateOperation.watterLevelVolume",
        name: "watterLevelVolume",
        dataType: "float"
    },
    {
        header: "TankStateOperation.productLevelHeight",
        name: "productLevelHeight",
        dataType: "int"
    },
    {
        header: "TankStateOperation.productLevelVolume",
        name: "productLevelVolume",
        dataType: "float"
    },
    {
        header: "TankStateOperation.temperature",
        name: "temperature",
        dataType: "float"
    },
    {
        header: "TankStateOperation.density",
        name: "density",
        dataType: "float"
    },
    {
        header: "TankStateOperation.weight",
        name: "weight",
        dataType: "float"
    },
    {
        header: "TankStateOperation.packageTs",
        name: "packageTs",
        dataType: "datetime"
    }
];


const TanksStateOperationsList = () => {
    const operations = useSelector(selectTanksStateOperations());
    const filter = useSelector(selectTanksStateOperationsFilter());
    const [loading, setLoading] = useState(false);
    const {t} = useLocalization();

    useEffect(() => {
        getData();
    }, []);

    const getData = async (filtr) => {
        filtr = filtr ? filtr : filter;
        setLoading(true);
        await tankService.getTanksStateOperationsAsync(filtr);
        setLoading(false);
    }

    const getReport = async (filter) => {
        appService.setLoading(true);
        const data = await tankService.getTankStateOperationsReportAsync(filter);
        appService.setLoading(false);
        if(data){
            FileSaver.saveAs(data, 'tanks_state_operations.xlsx');
        }        
    }

    const modelFilter = {
        tankName: {
            name: "tankName",
            type: "string",
            header: t('TankStateOperation.Filter.tankName'),
            value: filter.modelFilter.tankName
        },
        dateTime: {
            name: "dateTime",
            type: "dates",
            dateFrom: {
                name: "dateFrom",
                header: t("TankStateOperation.Filter.dateFrom"),
                value: filter.modelFilter.dateFrom
            },
            dateTo: {
                name: "dateTo",
                header: t("TankStateOperation.Filter.dateTo"),
                value: filter.modelFilter.dateTo
            }
        }
    };

    return (
        <div>
            <Table settings={{
                columns: Columns,
                items: operations,
                itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                isEditable: false,
                getItemsFunction: getData,
                getReportFunction: getReport
            }} />
            {loading && <Loader />}
        </div>
    );
}

export default TanksStateOperationsList;